import I18n from 'I18n';
import { FieldTypes } from 'forms-utils-lib/constants/formField/FieldTypeMapping';
const getDefaultMetaDataValues = (fieldType, locale) => {
  if (fieldType !== FieldTypes.DATE) return [];
  const longDateFormat = I18n.moment.localeData(locale).longDateFormat('L');
  const separator = longDateFormat.indexOf('/') > -1 ? '/' : longDateFormat.indexOf('-') > -1 ? '-' : '.';
  return [{
    name: 'format',
    value: longDateFormat.replace(new RegExp(separator, 'g'), '-')
  }, {
    name: 'separator',
    value: separator
  }];
};
export default getDefaultMetaDataValues;